var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftThigh = function SvgLeftThigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 135"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCCB",
    d: "M.5 53C.5 38 6.5 7 7 .5 9 3 14.1 9 18.5 13c5.5 5 10 7.5 16.5 17 5.2 7.6 12.167 18.5 15 23-.667 23.667-2.8 71.9-6 75.5-4 4.5-7 7.5-15.5 6S16 127 13 124s-2-8.5-6-17.5S.5 68 .5 53"
  })));
};
export default SvgLeftThigh;